
import { useLocation, useNavigate } from "react-router-dom";
import { coachPaths } from "../../../../routes/coach";

const Build = () => {
  const navigate = useNavigate()
  const { state } = useLocation();

  return (
    <div>
      <section
        class="ct_looking_for_work_bg ct_looking_for_work_bg_left ct_mt_100"
        data-aos="fade-down"
        data-aos-duration="1500"
      >
        <div class="d-flex align-items-center gap-lg-5 gap-3 ct_flex_col_767 ">
          <div class="text-white">
            <h4 class="ct_fs_36 mb-4"> Ready to Build With Confidence?</h4>
            <p class="mb-0 ct_fs_18">
              {" "}
              Explore how Nuvio can help you grow your idea, team, or business
              on your terms.
            </p>
          </div>
          <div class="ct_flex_shrink_0">
            <a
              onClick={() => navigate(coachPaths?.ContactUs, {
                state: {
                  data: state?.data === "landing" ? "landing" : "",
                },
              })}
              class="ct_yellow_btn ct_darkblue_btn ct_flex_1 px-5"
            >
              {" "}
              Get Started
            </a>
          </div>
        </div>
      </section>
      <section
        className="ct_px_40 ct_pt_100 "
        data-aos="fade-down"
        data-aos-duration="1500"
      >
        <div className="container-fluid">
          {/* <div className="row">
            <div className="col-md-12">
              <div class="owl-carousel owl-theme ct_coach_created_slider ct_owl_nav_none">
                <div class="item">
                  <div className="ct_testi_card">
                    <div className="d-flex align-items-center justify-content-between gap-2">
                      <div className="d-flex align-items-center gap-1">
                        <i class="fa-solid fa-star ct_orange_text"></i>
                        <i class="fa-solid fa-star ct_orange_text"></i>
                        <i class="fa-solid fa-star ct_orange_text"></i>
                        <i class="fa-solid fa-star ct_orange_text"></i>
                        <i class="fa-solid fa-star ct_orange_text"></i>
                      </div>
                      <p className="mb-0 ct_darkblue_text">20th April, 2025</p>
                    </div>
                    <p className="mt-3 mb-0 ct_darkblue_text">
                      The expert sessions and networking inside NuForge are next
                      level. I finally feel part of a serious community that
                      pushes me to grow.
                    </p>

                    <div className="d-flex align-items-center gap-3 mt-4">
                      <img
                        src="/assets/img/user_33.jpg"
                        className="ct_img_w_60"
                      />
                      <div>
                        <h4 className="ct_fs_18 ct_darkblue_text mb-1">
                          Alex Robertson
                        </h4>
                        <p className="mb-0 ct_darkblue_text">
                          Frontend Developer
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="item">
                  <div className="ct_testi_card">
                    <div className="d-flex align-items-center justify-content-between gap-2">
                      <div className="d-flex align-items-center gap-1">
                        <i class="fa-solid fa-star ct_orange_text"></i>
                        <i class="fa-solid fa-star ct_orange_text"></i>
                        <i class="fa-solid fa-star ct_orange_text"></i>
                        <i class="fa-solid fa-star ct_orange_text"></i>
                        <i class="fa-solid fa-star ct_orange_text"></i>
                      </div>
                      <p className="mb-0 ct_darkblue_text">20th April, 2025</p>
                    </div>
                    <p className="mt-3 mb-0 ct_darkblue_text">
                      The expert sessions and networking inside NuForge are next
                      level. I finally feel part of a serious community that
                      pushes me to grow.
                    </p>

                    <div className="d-flex align-items-center gap-3 mt-4">
                      <img
                        src="/assets/img/user_33.jpg"
                        className="ct_img_w_60"
                      />
                      <div>
                        <h4 className="ct_fs_18 ct_darkblue_text mb-1">
                          Alex Robertson
                        </h4>
                        <p className="mb-0 ct_darkblue_text">
                          Frontend Developer
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="item">
                  <div className="ct_testi_card">
                    <div className="d-flex align-items-center justify-content-between gap-2">
                      <div className="d-flex align-items-center gap-1">
                        <i class="fa-solid fa-star ct_orange_text"></i>
                        <i class="fa-solid fa-star ct_orange_text"></i>
                        <i class="fa-solid fa-star ct_orange_text"></i>
                        <i class="fa-solid fa-star ct_orange_text"></i>
                        <i class="fa-solid fa-star ct_orange_text"></i>
                      </div>
                      <p className="mb-0 ct_darkblue_text">20th April, 2025</p>
                    </div>
                    <p className="mt-3 mb-0 ct_darkblue_text">
                      The expert sessions and networking inside NuForge are next
                      level. I finally feel part of a serious community that
                      pushes me to grow.
                    </p>

                    <div className="d-flex align-items-center gap-3 mt-4">
                      <img
                        src="/assets/img/user_33.jpg"
                        className="ct_img_w_60"
                      />
                      <div>
                        <h4 className="ct_fs_18 ct_darkblue_text mb-1">
                          Alex Robertson
                        </h4>
                        <p className="mb-0 ct_darkblue_text">
                          Frontend Developer
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="item">
                  <div className="ct_testi_card">
                    <div className="d-flex align-items-center justify-content-between gap-2">
                      <div className="d-flex align-items-center gap-1">
                        <i class="fa-solid fa-star ct_orange_text"></i>
                        <i class="fa-solid fa-star ct_orange_text"></i>
                        <i class="fa-solid fa-star ct_orange_text"></i>
                        <i class="fa-solid fa-star ct_orange_text"></i>
                        <i class="fa-solid fa-star ct_orange_text"></i>
                      </div>
                      <p className="mb-0 ct_darkblue_text">20th April, 2025</p>
                    </div>
                    <p className="mt-3 mb-0 ct_darkblue_text">
                      The expert sessions and networking inside NuForge are next
                      level. I finally feel part of a serious community that
                      pushes me to grow.
                    </p>

                    <div className="d-flex align-items-center gap-3 mt-4">
                      <img
                        src="/assets/img/user_33.jpg"
                        className="ct_img_w_60"
                      />
                      <div>
                        <h4 className="ct_fs_18 ct_darkblue_text mb-1 ct_darkblue_text">
                          Alex Robertson
                        </h4>
                        <p className="mb-0 ct_darkblue_text">
                          Frontend Developer
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="item">
                  <div className="ct_testi_card">
                    <div className="d-flex align-items-center justify-content-between gap-2">
                      <div className="d-flex align-items-center gap-1">
                        <i class="fa-solid fa-star ct_orange_text"></i>
                        <i class="fa-solid fa-star ct_orange_text"></i>
                        <i class="fa-solid fa-star ct_orange_text"></i>
                        <i class="fa-solid fa-star ct_orange_text"></i>
                        <i class="fa-solid fa-star ct_orange_text"></i>
                      </div>
                      <p className="mb-0 ct_darkblue_text">20th April, 2025</p>
                    </div>
                    <p className="mt-3 mb-0 ct_darkblue_text">
                      The expert sessions and networking inside NuForge are next
                      level. I finally feel part of a serious community that
                      pushes me to grow.
                    </p>

                    <div className="d-flex align-items-center gap-3 mt-4">
                      <img
                        src="/assets/img/user_33.jpg"
                        className="ct_img_w_60"
                      />
                      <div>
                        <h4 className="ct_fs_18 ct_darkblue_text mb-1">
                          Alex Robertson
                        </h4>
                        <p className="mb-0 ct_darkblue_text">
                          Frontend Developer
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div> */}
          <div className="row">
            <div className="col-lg-4 col-md-6 mb-4">
              <div class="ct_testimonial_review_card h-100 d-grid">
                <div>
                  <div className="d-flex align-items-center gap-3 mb-3 justify-content-between">
                    <div class="d-flex align-items-center gap-1">
                      <i class="fa-solid fa-star ct_orange_text ct_fs_16"></i>
                      <i class="fa-solid fa-star ct_orange_text ct_fs_16"></i>
                      <i class="fa-solid fa-star ct_orange_text ct_fs_16"></i>
                      <i class="fa-solid fa-star ct_orange_text ct_fs_16"></i>
                      <i class="fa-solid fa-star ct_orange_text ct_fs_16"></i>
                    </div>
                    <p className="mb-0 ct_fs_16">20th April, 2025</p>
                  </div>
                  <p className="mb-0 " style={{ maxWidth: "295px" }}>
                    The expert sessions and networking inside NuForge are next level. I finally feel part of a serious community that pushes me to grow.
                  </p>
                </div>
                <div className="mt-auto">
                  <div class="d-flex align-items-center gap-3 ct_mt_40">
                    <img
                      src="/assets/img/Ellipse 24.png"
                      class="ct_img_60 "
                      alt=""
                    />
                    <div>
                      <h5 class="ct_fs_18  mb-1 me-1 ct_grey_text">
                        Alex Robertson
                      </h5>
                      <p class="mb-0  ct_fs_16  ">Frontend Developer</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 mb-4">
              <div class="ct_testimonial_review_card h-100 d-grid">
                <div>
                  <div className="d-flex align-items-center gap-3 mb-3 justify-content-between">
                    <div class="d-flex align-items-center gap-1">
                      <i class="fa-solid fa-star ct_orange_text ct_fs_16"></i>
                      <i class="fa-solid fa-star ct_orange_text ct_fs_16"></i>
                      <i class="fa-solid fa-star ct_orange_text ct_fs_16"></i>
                      <i class="fa-solid fa-star ct_orange_text ct_fs_16"></i>
                      <i class="fa-solid fa-star ct_orange_text ct_fs_16"></i>
                    </div>

                    <p className="mb-0 ct_fs_16">20th April, 2025</p>
                  </div>
                  <p className="mb-0 " style={{ maxWidth: "295px" }}>
                    With NuForge, I refined my services, rebranded my profile, and doubled my client reach in just a few weeks. Totally worth it!
                  </p>
                </div>
                <div className="mt-auto">
                  <div class="d-flex align-items-center gap-3 ct_mt_40">
                    <img
                      src="/assets/img/Ellipse 24 (1).png"
                      class="ct_img_60 "
                      alt=""
                    />
                    <div>
                      <h5 class="ct_fs_18  mb-1 me-1 ct_grey_text">
                        Olivia Brooks
                      </h5>
                      <p class="mb-0  ct_fs_16  ">Mobile App Developer</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 mb-4">
              <div class="ct_testimonial_review_card h-100 d-grid">
                <div>
                  <div className="d-flex align-items-center gap-3 mb-3 justify-content-between">
                    <div class="d-flex align-items-center gap-1">
                      <i class="fa-solid fa-star ct_orange_text ct_fs_16"></i>
                      <i class="fa-solid fa-star ct_orange_text ct_fs_16"></i>
                      <i class="fa-solid fa-star ct_orange_text ct_fs_16"></i>
                      <i class="fa-solid fa-star ct_orange_text ct_fs_16"></i>
                      <i class="fa-solid fa-star ct_orange_text ct_fs_16"></i>
                    </div>

                    <p className="mb-0 ct_fs_16">20th April, 2025</p>
                  </div>
                  <p className="mb-0 " style={{ maxWidth: "295px" }}>
                    NuForge helped me position myself for higher-paying clients by improving my portfolio and strategy.
                  </p>
                </div>
                <div className="mt-auto">
                  <div class="d-flex align-items-center gap-3 ct_mt_40">
                    <img
                      src="/assets/img/Ellipse 24 (2).png"
                      class="ct_img_60 "
                      alt=""
                    />
                    <div>
                      <h5 class="ct_fs_18  mb-1 me-1 ct_grey_text">
                        James Thornton
                      </h5>
                      <p class="mb-0  ct_fs_16  ">Cloud Solutions Architect</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Build;
